import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

/**
 * Os gráficos do sistema.
 *
 * Recharts puro, com invólucro próprio. Não entram shadcn/ui nem Tremor: o
 * único vão real aqui era gráfico — botão, tabela responsiva, diálogo e até o
 * cartão de indicador já existem à mão —, e as duas trariam um vocabulário de
 * tokens concorrente num app que é dark-only e cuja paleta carrega regra de
 * negócio (brasa é ação de gente, projeção é a máquina).
 *
 * As cores saem dos tokens do tema, não de uma paleta categórica: um gráfico de
 * custo mostra dinheiro gasto pela máquina, e a cor disso já está decidida.
 */

const EIXO = "oklch(0.55 0.012 70)"; // --color-texto-fraco
const GRADE = "oklch(0.32 0.016 60)"; // --color-borda

export interface PontoDeBarra {
  rotulo: string;
  valor: number;
  /** Destaca uma barra — a que está aberta no drill-down. */
  ativo?: boolean;
}

export function Barras({
  dados,
  formatar,
  aoClicar,
  altura = 240,
}: {
  dados: PontoDeBarra[];
  formatar: (v: number) => string;
  aoClicar?: (rotulo: string) => void;
  altura?: number;
}) {
  return (
    <div style={{ height: altura }} className="w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={dados} margin={{ top: 4, right: 8, bottom: 4, left: 8 }}>
          <CartesianGrid stroke={GRADE} strokeDasharray="2 4" vertical={false} />
          <XAxis
            dataKey="rotulo"
            stroke={EIXO}
            tickLine={false}
            axisLine={false}
            fontSize={12}
            // Nome de casa e de evento são longos; cortar é melhor que sobrepor.
            tickFormatter={(v: string) => (v.length > 14 ? `${v.slice(0, 13)}…` : v)}
          />
          <YAxis
            stroke={EIXO}
            tickLine={false}
            axisLine={false}
            fontSize={12}
            width={56}
            tickFormatter={formatar}
          />
          <Tooltip
            cursor={{ fill: "oklch(0.27 0.015 60)" }}
            contentStyle={{
              background: "oklch(0.22 0.014 60)",
              border: "1px solid oklch(0.32 0.016 60)",
              borderRadius: "0.375rem",
              fontSize: "0.8125rem",
            }}
            labelStyle={{ color: "oklch(0.96 0.008 75)" }}
            // O valor também: sem isto ele herda o cinza-escuro padrão do
            // Recharts, ilegível sobre a superfície escura do sistema.
            itemStyle={{ color: "oklch(0.96 0.008 75)" }}
            formatter={(v) => [formatar(Number(v ?? 0)), "custo"]}
          />
          <Bar
            dataKey="valor"
            radius={[3, 3, 0, 0]}
            onClick={aoClicar ? (d: unknown) => aoClicar((d as PontoDeBarra).rotulo) : undefined}
            cursor={aoClicar ? "pointer" : undefined}
          >
            {dados.map((d) => (
              <Cell
                key={d.rotulo}
                fill={d.ativo ? "var(--color-brasa)" : "var(--color-projecao)"}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
